module.exports = __webpack_public_path__ + "static/media/grains.dd8ed01b.psd";